import sourceEvent from "./sourceEvent";
import point from "./point";
export default function (node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/mouse.js
// module id = 453
// module chunks = 0